export const PLAN_STRUCTURE_TEMPLATE = 'template';
export const PLAN_STRUCTURE_EMPTY = 'empty';

export const PLAN_TYPE_KEY_RESIDENT = 'reentry';
export const PLAN_TYPE_KEY_TEMPLATE = 'template';

export const RESIDENT_PLAN_TYPE = {
  key: PLAN_TYPE_KEY_RESIDENT,
  name: 'Resident Plan',
  description: 'A structured plan tied to one resident.',
};

export const TEMPLATE_PLAN_TYPE = {
  key: PLAN_TYPE_KEY_TEMPLATE,
  name: 'Template',
  description:
    'A reusable structure to start new plans from, with no resident attached.',
};

/** Bulk-create result statuses from POST /api/admin/case-plan. */
export const CREATE_RESULT_STATUS = {
  CREATED: 'created',
  SKIPPED: 'skipped',
};

export const PERSON_ROLE_LEARNER = 'Learner';
export const PERSON_ROLE_STAFF = 'Staff';

export const CREATE_PLAN_TOAST = {
  SUCCESS_ONE: 'Plan created successfully',
  SUCCESS_MANY: 'Plans created successfully',
  PARTIAL: (createdCount, problemCount) =>
    `${createdCount} plan(s) created. ${problemCount} resident(s) were skipped.`,
  ALL_FAILED:
    'No plans were created. One or more residents already have a plan or could not be processed.',
  CAP_REACHED:
    'Cap reached. One or more residents already have a reentry plan.',
  REQUEST_FAILED: 'Failed to create plan. Please try again.',
};

/** HTTP status for per-plan_type create cap collision (CC-14981 AC#5). */
export const CREATE_PLAN_CAP_COLLISION_STATUS = 409;

export const MUI_AUTOCOMPLETE_POPPER_SELECTOR = '.MuiAutocomplete-popper';
